// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2f2f798a","455":"c2f0628b"}[chunkId] + ".chunk.js";
};